import { render, staticRenderFns } from "./ProofOfDelivery.vue?vue&type=template&id=50b4c62a&scoped=true&"
import script from "./ProofOfDelivery.vue?vue&type=script&lang=js&"
export * from "./ProofOfDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ProofOfDelivery.vue?vue&type=style&index=0&id=50b4c62a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b4c62a",
  null
  
)

export default component.exports